import { Box, Button, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import Login_img from "../../images/png/01_Login.png";
import Serial_img from "../../images/png/02_Serial_ID.png";
import Pair_img from "../../images/png/03_Pair.png";

const useStyles = makeStyles((theme) => ({
  button: {
    width: "100%",
    maxWidth: "15rem",
  },
  image_cont: {
    height: "auto",
    maxWidth: "228px",
  },
}));

const NoticesPairEklokContainer = ({ setNotices }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box>
      <Box display="flex" justifyContent="center" mb={4}>
        <Typography variant="h4">
          {t("pair_eklok.notice.title").toUpperCase()}
        </Typography>
      </Box>
      <Grid container>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mr={4}
            ml={4}
          >
            <Typography variant="h5">
              {t("pair_eklok.notice.login_text")}
            </Typography>
            <Box>
              <img alt="login" src={Login_img} className={classes.image_cont} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mr={4}
            ml={4}
          >
            <Typography variant="h5">
              {t("pair_eklok.notice.enter_text")}
            </Typography>
            <Box mt={3}>
              <img
                alt="enter"
                src={Serial_img}
                className={classes.image_cont}
              />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            mr={4}
            ml={4}
          >
            <Typography variant="h5">
              {t("pair_eklok.notice.confirm_text")}
            </Typography>
            <Box>
              <img
                alt="confirm"
                src={Pair_img}
                className={classes.image_cont}
              />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box mt={5} mb={3} display="flex" justifyContent="center">
            <Button
              className={classes.button}
              color="primary"
              variant="contained"
              onClick={() => setNotices(false)}
            >
              {t("pair_eklok.notice.confirm_button")}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default NoticesPairEklokContainer;
